     <!-- <div *ngIf="sliderClass!=''" >
               <div class="bgSlider1" style="background-image: url({{item.image_url}})">       
                
            </div>
          </div> -->

        

    <div id="slider{{sliderClass}}" class="carousel {{sliderClass}} slide carousel-fade">

   <div>
     
      <ol class="carousel-indicators {{yuvarlakToplar(sliderClass)}}" id="caruselToplar">
        <li attr.data-target="#slider{{sliderClass}}" *ngFor="let item of sayi ; let indexOfelement=index;"  [attr.data-slide-to]="item" class="toplar {{activeClass(this.indexOfelement)}}"></li>     
      </ol>

   </div>
     
      <div class="carousel-inner">
        <div class="carousel-item  {{activeClass(this.indexOfelement)}} "  *ngFor="let item of sliderModel.sliders; let indexOfelement=index;">
          <a *ngIf="item.content_type != elinkTypeEnum.externalLink " routerLink="/{{rootModel.language}}/slider/{{item.sli_uid}}/{{item.title}}"> 
            <img class="d-block w-100"  src="{{item.image_url}}" width="auto"  height="{{heightDeger(sliderClass)}}"  alt="First slide">
                    
          </a>   
          <a *ngIf="item.content_type == elinkTypeEnum.externalLink " href="{{item.external_link}} " > 
            <img class="d-block w-100"  src="{{item.image_url}}" width="auto"  height="{{heightDeger(sliderClass)}}"  alt="First slide">
          
          
          </a> 

          <div class="carousel-caption d-none d-md-block">
         
            <!-- <a *ngIf="item.content_type != elinkTypeEnum.externalLink " routerLink="/{{rootModel.language}}/slider/{{item.sli_uid}}/{{item.title}}" class="sliderTitle"> {{item.title}}   </a>  
            <a *ngIf="item.content_type == elinkTypeEnum.externalLink " href="{{item.external_link}} "  class="sliderTitle"> {{item.title}}  </a>    -->

          </div>        
     
        </div> 

      </div>
      <!-- <a class="carousel-control-prev" href="#slider{{sliderClass}}" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next"  style="z-index: 9999;" href="#slider{{sliderClass}}" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>

        <span class="sr-only">Next</span>
      </a> -->
    </div> 

    


 
